var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 38,
    viewBox: "0 0 142 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6705 18.8021L11.2377 28.2112L8.89606 32.2619L0 27.1241L4.81615 18.7835L0 10.443L8.89872 5.31586L11.134 9.17516L16.6678 18.7623C16.6674 18.7756 16.6683 18.789 16.6705 18.8021Z",
    fill: "url(#paint0_linear_1755_1996)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.19 18.7862C45.19 21.2527 44.7042 23.6951 43.7602 25.9739C42.8162 28.2527 41.4326 30.3232 39.6883 32.0672C37.9441 33.8112 35.8734 35.1945 33.5945 36.1382C31.3156 37.0819 28.8731 37.5674 26.4065 37.567H12.0538L13.5262 35.0261L17.4068 28.3015H26.4065C27.6697 28.3226 28.9244 28.0921 30.0975 27.6233C31.2706 27.1545 32.3386 26.4569 33.2394 25.5711C34.1401 24.6853 34.8555 23.6291 35.3438 22.4639C35.8321 21.2988 36.0836 20.0482 36.0836 18.7849C36.0836 17.5215 35.8321 16.2709 35.3438 15.1058C34.8555 13.9406 34.1401 12.8844 33.2394 11.9986C32.3386 11.1128 31.2706 10.4152 30.0975 9.94639C28.9244 9.47761 27.6697 9.24706 26.4065 9.26817H17.3032L13.5262 2.72703L11.9528 0H26.4065C28.8734 -2.46975e-08 31.3162 0.485938 33.5953 1.43006C35.8744 2.37419 37.9452 3.75801 39.6894 5.50251C41.4337 7.247 42.8172 9.31799 43.761 11.5972C44.7048 13.8764 45.1904 16.3193 45.19 18.7862Z",
    fill: "url(#paint1_linear_1755_1996)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 11H66.2417C71.4679 11 74.7742 13.9122 74.7742 18.5587C74.7742 23.2052 71.491 26.0292 66.2417 26.0292H60V11ZM66.2417 23.2423C69.5944 23.2423 71.6997 21.4152 71.6997 18.5216C71.6997 15.628 69.5712 13.7823 66.2417 13.7823H62.889V23.2423H66.2417Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5906 11H92.8593V13.7823H81.4842V16.88H91.6119V19.6623H81.4842V23.2005L92.8593 23.2237V26.0061H78.5906V11Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4828 11H111.752V13.7823H100.376V16.88H110.504V19.6623H100.376V23.2005L111.752 23.2237V26.0061H97.4828V11Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114.854 26.3863H125.097V29.1686H114.854V26.3863Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M132.586 18.4196L127.11 11H130.922L134.414 15.7392L137.72 11H141.536L136.171 18.1228L142 26.0061H138.184L134.321 20.7567L130.667 26.0061H126.855L132.586 18.4196Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1755_1996",
    x1: 0,
    y1: 18.7835,
    x2: 16.6705,
    y2: 18.7835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAF26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F85D31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1755_1996",
    x1: 11.9528,
    y1: 18.7835,
    x2: 45.19,
    y2: 18.7835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0EB4E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B75C2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkLogo);
export default __webpack_public_path__ + "static/media/darkLogo.e7ec66779de24b662ab935bac91b9e85.svg";
export { ForwardRef as ReactComponent };